import {watchGetArticleHeaderClassrooms} from './articleHeaderClassroomSagas';
import {watchGetArticleHeader} from './articleHeaderSagas';
import {watchGetArticleWords} from './articleWordSagas';
import {
  watchGetAssignments,
  watchStartAssignmentsPolling,
} from './assignmentSagas';
import {
  watchGetClassrooms,
  watchCreateClassroom,
  watchJoinClassroom,
  watchStartClassroomPolling,
} from './classroomSagas';
import {
  watchGetContentHides,
  watchToggleContentHide,
} from './contentHideSagas';
import {
  watchGetContentRow,
} from './contentRowSagas';
import {watchGetModelsByPrimaryKeys} from './genericModelSagas';
import {watchGetLessonSparkViewRecords} from './lessonSparkViewRecordSagas';
import {
  watchPollForNotifications,
  watchInitNotifications,
} from './notificationsSagas';
import {watchGetRecentNews} from './recentNewsSagas';
import {watchGetSearch} from './searchSagas';
import {watchRequestUserSignOut} from './sessionSagas';
import {watchGetStudentAssignmentViews} from './studentAssignmentViewSagas';
import {watchGetStudentQuizzes} from './studentQuizSagas';
import {watchGetStudies} from './studiesSagas';
import {
  watchPersistTextSet,
  watchAddHeaderToTextSet,
  watchRemoveHeaderFromTextSet,
  watchGetTextSet,
} from './textSetSagas';
import {
  watchGetCurrentUser,
  watchCreateNewUser,
  watchRefreshCurrentUser,
} from './userSagas';

const commonSagas = [
  watchPollForNotifications,
  watchAddHeaderToTextSet,
  watchCreateClassroom,
  watchJoinClassroom,
  watchGetArticleHeader,
  watchGetArticleWords,
  watchGetArticleHeaderClassrooms,
  watchGetAssignments,
  watchStartAssignmentsPolling,
  watchGetClassrooms,
  watchGetContentHides,
  watchGetContentRow,
  watchCreateNewUser,
  watchGetCurrentUser,
  watchGetModelsByPrimaryKeys,
  watchGetRecentNews,
  watchGetStudentQuizzes,
  watchGetLessonSparkViewRecords,
  watchGetSearch,
  watchGetStudies,
  watchGetTextSet,
  watchInitNotifications,
  watchPersistTextSet,
  watchRefreshCurrentUser,
  watchRequestUserSignOut,
  watchRemoveHeaderFromTextSet,
  watchStartClassroomPolling,
  watchToggleContentHide,
  watchGetStudentAssignmentViews,
];

export default commonSagas;
